/* Independent PDP membership media lifecycle, including Theme Editor reloads. */
(() => {
  if (customElements.get('guru-pdp-member-media')) return;
  class GuruPdpMemberMedia extends HTMLElement {
    #memberMediaObserver;
    connectedCallback() {
      this.#memberMediaObserver?.disconnect();
      this.#bindDeferredMemberMedia();
    }
    disconnectedCallback() {
      this.#memberMediaObserver?.disconnect();
      this.#memberMediaObserver = null;
    }
    #bindDeferredMemberMedia() {
      const shell = this.querySelector('[data-guru-pdp-member-media]');
      const hydrate = () => {
        const template = shell?.querySelector('template[data-guru-pdp-deferred-member-media]');
        if (!(template instanceof HTMLTemplateElement)) return;
        template.replaceWith(template.content.cloneNode(true));
      };
      if (!shell || !(shell.querySelector('template[data-guru-pdp-deferred-member-media]') instanceof HTMLTemplateElement)) return;
      if (!('IntersectionObserver' in window)) {
        hydrate();
        return;
      }
      this.#memberMediaObserver = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.#memberMediaObserver?.disconnect();
        this.#memberMediaObserver = null;
        hydrate();
      }, { rootMargin: '600px 0px' });
      this.#memberMediaObserver.observe(shell);
    }

  }
  customElements.define('guru-pdp-member-media', GuruPdpMemberMedia);
})();
